import React from "react";
import { Row, Space, Typography, Button, Spin } from "antd";

import { LoadingOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";

import AppContainer from "../../components/AppContainer/AppContainer";
import styles from "./styles/Setting.module.css";

const { Title } = Typography;

function Settings() {
  const token = localStorage.getItem("token");
  const { loginAs } = jwtDecode(token);

  const antIcon = <LoadingOutlined style={{ fontSize: 100 }} spin />;
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };
  return (
    <AppContainer>
      <div className={styles.container}>
        <center>
          <div className={styles.content}>
            <Row align="middle" justify="center" style={{ marginTop: 20 }}>
              <Title level={3} style={{ textAlign: "center" }}>
                Settings
              </Title>
            </Row>
            <div className={styles.info}>
              {loginAs ? (
                loginAs === "Administrator" ? (
                  <Space
                    size={"middle"}
                    direction={"vertical"}
                    style={{ width: "100%" }}
                  >
                    <Link to={`/v2/${loginAs}/accounts/user`}>
                      <Button block type="primary">
                        Accounts
                      </Button>
                    </Link>
                    <Link to={`/v2/${loginAs}/accounts/tre`}>
                      <Button block type="primary">
                        Establishments
                      </Button>
                    </Link>
                  </Space>
                ) : (
                  <>
                    <Link to={"/v2/accounts"}>
                      <Button block type="primary">
                        Accounts
                      </Button>
                    </Link>
                  </>
                )
              ) : (
                <>
                  <Row
                    justify="center"
                    align="middle"
                    style={{ height: 240, width: "100%" }}
                  >
                    <Spin indicator={antIcon} />
                  </Row>
                </>
              )}
            </div>
            <Button block danger onClick={logout} type="primary">
              LOGOUT
            </Button>
          </div>
        </center>
      </div>
    </AppContainer>
  );
}

export default Settings;
